import { render, staticRenderFns } from "./HabeasDataNotFound.vue?vue&type=template&id=e235a068&scoped=true"
import script from "./HabeasDataNotFound.vue?vue&type=script&lang=js"
export * from "./HabeasDataNotFound.vue?vue&type=script&lang=js"
import style0 from "./HabeasDataNotFound.vue?vue&type=style&index=0&id=e235a068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e235a068",
  null
  
)

export default component.exports